import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FirstSigninPopup from './FirstSigninPopup';
import ProductOnboardingFlow from './ProductOnboardingFlow';
import {
  isOnboardingPending,
} from '../../utils/onboardingStorage';

function isFirstSigninShown() {
  try { return localStorage.getItem('flea_web_first_signin_shown') === 'true'; } catch { return false; }
}

export default function OnboardingOrchestrator() {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const [phase, setPhase] = useState('idle');

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setPhase('idle');
      return;
    }

    const id = setTimeout(() => {
      const firstShown = isFirstSigninShown();
      if (!firstShown) {
        setPhase('first-signin');
      } else if (isOnboardingPending()) {
        setPhase('product-onboarding');
      } else {
        setPhase('done');
      }
    }, 900);

    return () => clearTimeout(id);
  }, [isAuthenticated, user]);

  const handleFirstSigninComplete = () => {
    if (isOnboardingPending()) {
      setPhase('product-onboarding');
    } else {
      setPhase('done');
    }
  };

  const handleProductOnboardingClose = () => {
    setPhase('done');
  };

  if (phase === 'first-signin') {
    return <FirstSigninPopup onComplete={handleFirstSigninComplete} />;
  }

  if (phase === 'product-onboarding') {
    return <ProductOnboardingFlow onClose={handleProductOnboardingClose} />;
  }

  return null;
}
